var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFiletypeTxt(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm11 3v-3h-9v16h12v-13z', fill: '#0089d9' }),
        React.createElement("path", { d: 'm11.873 12.41936a2.2037 2.2037 0 0 1 -.533-.871l-3.26894-7.54836h-.24873l-2.73594 6.53226a12.3528 12.3528 0 0 1 -.85276 1.81451 1.09276 1.09276 0 0 1 -.74617.39919v.25404h2.59383v-.254a4.52086 4.52086 0 0 1 -.63958-.10887.48718.48718 0 0 1 -.28426-.47178 1.66763 1.66763 0 0 1 .10661-.47176c.07106-.18147.28424-.72581.604-1.59679h3.48214l.533 1.27017a4.46415 4.46415 0 0 1 .17767.50807c.03553.18144.071.29031.071.32661a.36411.36411 0 0 1 -.17765.3629 2.29424 2.29424 0 0 1 -.74617.10886v.254h3.30447v-.254a.88734.88734 0 0 1 -.63952-.25405zm-5.75619-2.90323 1.52787-3.66533 1.49232 3.66533z', fill: '#fff' }),
        React.createElement("path", { d: 'm11 0 3 3h-3z', fill: '#006097' })));
}
export default SvgFiletypeTxt;
